var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstaCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    stroke: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_898_2940)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3335 16.6668C13.3335 15.7828 13.6847 14.9349 14.3098 14.3098C14.9349 13.6847 15.7828 13.3335 16.6668 13.3335H23.3335C24.2176 13.3335 25.0654 13.6847 25.6905 14.3098C26.3156 14.9349 26.6668 15.7828 26.6668 16.6668V23.3335C26.6668 24.2176 26.3156 25.0654 25.6905 25.6905C25.0654 26.3156 24.2176 26.6668 23.3335 26.6668H16.6668C15.7828 26.6668 14.9349 26.3156 14.3098 25.6905C13.6847 25.0654 13.3335 24.2176 13.3335 23.3335V16.6668Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 20C17.5 20.663 17.7634 21.2989 18.2322 21.7678C18.7011 22.2366 19.337 22.5 20 22.5C20.663 22.5 21.2989 22.2366 21.7678 21.7678C22.2366 21.2989 22.5 20.663 22.5 20C22.5 19.337 22.2366 18.7011 21.7678 18.2322C21.2989 17.7634 20.663 17.5 20 17.5C19.337 17.5 18.7011 17.7634 18.2322 18.2322C17.7634 18.7011 17.5 19.337 17.5 20Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.75 16.25V16.2583",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_898_2940"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstaCircle);
export default __webpack_public_path__ + "static/media/InstaCircle.c4c239590b6739699baa8bdf00c7624f.svg";
export { ForwardRef as ReactComponent };